import classNames from 'classnames';

type Props = {
  className?: string;
  children: React.ReactNode;
};

const ProductBadge = ({ children, className }: Props) => {
  return (
    <span
      className={classNames(
        'flex w-fit items-center justify-center rounded bg-red-500 px-2 py-1 text-[12px] uppercase text-white',
        className,
      )}
    >
      {children}
    </span>
  );
};

export default ProductBadge;
